<div mat-dialog-title class="dialog-title font-normal">Filter Name</div>
<div mat-dialog-content>
  <input matInput class="save-input font-normal" [(ngModel)]="data.filterName" [attr.maxLength]="200"
    placeholder="Enter Filter Name" (keyup.enter)="isSaveDisabled() ? '' : save()">
</div>
<div mat-dialog-actions align="end" class="font-normal">
  <button mat-button class="cancel-button" mat-dialog-close>Cancel</button>
  <button mat-button color="primary" class="save-button" [disabled]="isSaveDisabled()" (click)="save()">Save & Apply</button>
</div>